import React from "react"

function SidebarMenu({ children }) {
  return <ul className="nav side-menu">{children}</ul>
}

export default SidebarMenu
